import { jsx as _jsx } from "react/jsx-runtime";
import { ContentGatePopup } from "../ContentGatePopup";
import { useContentGateRestrictions } from "./hooks/useContentGateRestrictions";
export const ContentGate = ({ languages, logoSrc, title, whyContentRestricted, restrictions, }) => {
    const { activeRestrictions, isDialogOpen } = useContentGateRestrictions(restrictions);
    return (_jsx(ContentGatePopup, { title: title, logoSrc: logoSrc, languages: languages, whyContentRestricted: whyContentRestricted, restrictions: activeRestrictions, isOpen: isDialogOpen }));
};
//# sourceMappingURL=ContentGate.js.map